var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',{staticClass:"tms-title"},[_vm._v(_vm._s(_vm.acctName))]),_c('div',{staticClass:"accounting mt-md-4"},[_c(_vm.selectedAccountingType,{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }